<template>
  <div>
    <div><img :src="pay.flag" :alt="pay.name" /></div>
    
    <div class="card-info">
    <h4>{{ pay.name }}</h4>
    <div> <span>Population:</span> {{ pay.population.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
    <div> <span>Region:</span> {{ pay.region}}</div>
    <div> <span>Capital:</span> {{ pay.capital}}</div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "cards",
  props: ["pay"],
  data() {
    return {};
  },
};
</script>



